var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{active: _vm.isActive},attrs:{"type":"button"},on:{"click":_vm.toggle}},[_vm._t("default",null,{"isActive":_vm.isActive,"toggle":_vm.toggle})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }